export default function ObjectSizeIcon() {
    return <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_2962_7159)">
            <path d="M2 3.33301H9.33333" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 4.66667L9.33333 3.33333L8 2" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M3.33333 2L2 3.33333L3.33333 4.66667" stroke="white" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M12.667 6.66699V14.0003" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11.333 12.667L12.6663 14.0003L13.9997 12.667" stroke="white" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path d="M13.9997 8.00033L12.6663 6.66699L11.333 8.00033" stroke="white" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path
                d="M2 8.00033C2 7.6467 2.14048 7.30757 2.39052 7.05752C2.64057 6.80747 2.97971 6.66699 3.33333 6.66699H8C8.35362 6.66699 8.69276 6.80747 8.94281 7.05752C9.19286 7.30757 9.33333 7.6467 9.33333 8.00033V12.667C9.33333 13.0206 9.19286 13.3598 8.94281 13.6098C8.69276 13.8598 8.35362 14.0003 8 14.0003H3.33333C2.97971 14.0003 2.64057 13.8598 2.39052 13.6098C2.14048 13.3598 2 13.0206 2 12.667V8.00033Z"
                stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
        </g>
        <defs>
            <clipPath id="clip0_2962_7159">
                <rect width="16" height="16" fill="white"/>
            </clipPath>
        </defs>
    </svg>

}